export function calculateMaxAge(expiresAt?: string | number | Date): number {
  if (!expiresAt) {
    return 7 * 24 * 60 * 60; // 7 days default
  }

  let expiryDate: Date;

  if (expiresAt instanceof Date) {
    expiryDate = expiresAt;
  } else if (typeof expiresAt === "number") {
    // Convert to milliseconds if in seconds (Unix timestamp < year 3000)
    const milliseconds = expiresAt > 1_000_000_000_000 ? expiresAt : expiresAt * 1000;
    expiryDate = new Date(milliseconds);
  } else {
    expiryDate = new Date(expiresAt);
  }

  const maxAgeSeconds = Math.floor((expiryDate.getTime() - Date.now()) / 1000);

  // Return default if invalid, or cap at 365 days
  if (maxAgeSeconds <= 0) return 7 * 24 * 60 * 60;
  if (maxAgeSeconds > 365 * 24 * 60 * 60) return 365 * 24 * 60 * 60;

  return maxAgeSeconds;
}
